// extracted by mini-css-extract-plugin
export var root = "tags-module--root--e8782";
export var tag = "tags-module--tag--f4b45";